export default __webpack_public_path__ + "static/media/skyblue.965f42a1.jpg";